
import { defineComponent } from "vue";

export default defineComponent({
  components: {},
  data() {
    return {
      showMap: true,
      showGraphForm: false,
    };
  },
});
